import { SceneBase } from '@jollywise/jollygoodgame';
import { KEYS } from 'game/constants/SceneConstants';
import { DisplayScoreProgress } from 'game/display/DisplayScoreProgress';

export class ModalScores extends SceneBase {
  constructor() {
    super({ key: KEYS.ModalScores, active: false });
  }

  create() {
    this.game.hud.setState('SCORE_MODAL');
    this.game.hud.events.on('CLOSE_SCORES_MODAL', this.closeOverlay, this);
    this.overlayBg = this.add
      .rectangle(0, 0, this.game.defaultWidth, this.game.defaultHeight, 0x000000)
      .setOrigin(0);
    this.overlayBg.alpha = 0.8;

    this.bg = this.add.sprite(0, 0, 'backgrounds', `background_score_header`).setOrigin(0);
    this.bg.y = -this.bg.height;

    this.scoresContainer = this.add.container(840, 30);
    this.scoresContainer.alpha = 0;

    this.add.tween({
      targets: this.bg,
      y: 0,
      duration: 300,
      ease: Phaser.Math.Easing.Back.In,
      onComplete: () => {
        this.game.soundController.playSFX('sfx', 'chn_score_slider');

        this.displayScores();
      },
    });
  }

  displayScores() {
    const scores = this.game._scores.getScores;

    let count = 0;

    // loop over the object value and display the scores
    for (const [type, value] of Object.entries(scores)) {
      // phaser workout odd / even based on index
      const isEven = count % 2 === 0;

      const scoreProgress = new DisplayScoreProgress(this, {
        x: 840,
        y: 0,
        type,
        score: value,
      });

      scoreProgress.x += isEven ? scoreProgress.width / 2 + 10 : -scoreProgress.width / 2 - 10;
      if (count >= 2) {
        scoreProgress.y += scoreProgress.height + 10;
      }

      this.scoresContainer.add(scoreProgress);
      count++;
    }

    this.add.tween({
      targets: this.scoresContainer,
      alpha: 1,
      duration: 300,
      ease: Phaser.Math.Easing.Back.In,
    });
  }

  closeOverlay() {
    this.add.tween({
      targets: this.scoresContainer,
      alpha: 0,
      duration: 300,
      ease: Phaser.Math.Easing.Back.Out,
      onComplete: () => {
        this.add.tween({
          targets: this.bg,
          y: -this.bg.height,
          duration: 300,
          ease: Phaser.Math.Easing.Back.Out,
          onComplete: () => {
            this.game.soundController.playSFX('sfx', 'chn_score_slider');

            this.game.sceneController.removeOverlayScene();
            this.shutdown();
          },
        });
      },
    });
  }

  shutdown() {
    this.game.hud.events.off('CLOSE_SCORES_MODAL', this.closeOverlay, this);
  }
}
